import { useQuery, UseQueryOptions } from 'react-query';
import { getMedicalRecordById } from '@services/external/medicalRecords.api';
import { useAppSelector } from '@hooks/app/redux';

async function handler(params: { recordId: string; providerId: string; clientId: string }) {
  const { data } = await getMedicalRecordById(params.providerId, params.clientId, params.recordId);

  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useMedicalRecordDetail(
  clientId?: string,
  recordId?: string,
  options?: UseQueryOptions<TQueryData | null, unknown, TQueryData, any>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery(
    ['medicalRecords:detail', providerId, recordId, clientId],
    recordId && clientId ? () => handler({ providerId, recordId, clientId }) : async () => null,
    { ...options, enabled: !!recordId && !!clientId },
  );
}

export default useMedicalRecordDetail;
